import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useState } from "react";
import { Link } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { sendPasswordResetCall } from "./sendPasswordResetEmail";
import LoadingModal from "../utils/LoadingModal";
import { isEmailValid } from "../utils/checks";
// import Toast from "../Toast/Toast";
// import { auth } from "../../firebase";
import "./styles.css";
import textProperties from "../utils/textProperties";

function SignIn({ value }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setIsModalOpen(false);
  };
  // const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // Added state for error message
  // const [showToast, setShowToast] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const auth = getAuth();
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isEmailValid(email)) {
      setIsModalOpen(true);
      try {
        const userCredential = await signInWithEmailAndPassword(
          auth,
          email,
          password
        );
        const user = userCredential.user;
        window.location.reload();
        handleClose();

        console.log(user);
      } catch (error) {
        const errorCode = error.code;
        // const errorMessage = error.message;
        setIsModalOpen(false);
        setErrorMessage(textProperties?.firebaseError?.[errorCode]);
      }
    } else {
      setErrorMessage(textProperties?.userDetails?.invalidEmail); // Set the error message
    }
  };

  function passwordResetEmailCall() {
    sendPasswordResetCall(email);
  }

  const defaultTheme = createTheme();

  return (
    <div className="signin-Modal">
      <LoadingModal open={isModalOpen} text={"Signing in..."}/>
      <span onClick={handleOpen} className="login-span">
        {value}
      </span>
      <Modal
        open={open}
        onClose={handleClose}
        onKeyDown={(e) => e.stopPropagation()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "grey",
          margin: "auto",
        }}
      >
        <>
          <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="xs">
              <CssBaseline />
              <Box
                sx={{
                  marginTop: 8,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  backgroundColor: "white",
                  opacity: "1 !important",
                  borderRadius: "2rem",
                  padding: "3rem",
                  boxShadow: "0 5px 5rem 15px gray",
                  height: "37rem",
                }}
              >
                <Avatar sx={{ m: 1, bgcolor: "rgb(234, 83, 85)" }}>
                  <LockOutlinedIcon style={{ color: "white" }} />
                </Avatar>
                <Typography component="h1" variant="h5">
                  {textProperties.signIn}
                </Typography>
                <Box
                  component="form"
                  onSubmit={handleSubmit}
                  noValidate
                  sx={{ mt: 1 }}
                >
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label={textProperties.emailAddress}
                    name={textProperties.email}
                    autoComplete="email"
                    autoFocus
                    onChange={(e) => setEmail(e.target.value)}
                    inputProps={{
                      style: { borderColor: "rgb(234, 83, 85)" }, // Set the outline color to red //
                    }}
                    error={email?.length > 0 && !isEmailValid(email)}
                    helperText={
                      email?.length > 0 && !isEmailValid(email)
                        ? textProperties.userDetails.invalidEmail
                        : ""
                    }
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label={textProperties.password}
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="remember"
                        style={{ color: "rgb(234, 83, 85)" }}
                      />
                    }
                    label={textProperties.rememberMe}
                  />
                  {/* Error message */}
                  {errorMessage && (
                    <p
                      style={{
                        color: "red",
                        textAlign: "center",
                        margin: "1px",
                      }}
                    >
                      {errorMessage}
                    </p>
                  )}

                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    style={{
                      backgroundColor: "rgb(234, 83, 85)",
                      color: "white",
                    }}
                  >
                    {textProperties.signIn}
                  </Button>
                  {/* <Grid container>
                  <Grid item xs>
                    <Link href="#" variant="body2">
                      Forgot password?
                    </Link>
                  </Grid>
                  <Grid item>
                    New User?{" "}
                    <Link to="/signup" variant="body2" className="link-text" onClick={handleClose}>
                      Sign Up
                    </Link>
                  </Grid>
                </Grid> */}
                  <div className="signin-bottom">
                    <Grid container>
                      <Grid item xs>
                        <Link
                          href="#"
                          variant="body2"
                          onClick={passwordResetEmailCall}
                          style={{ color: "#ea5355" }}
                        >
                          {textProperties.forgotPassword}
                        </Link>
                      </Grid>
                      <Grid item style={{ marginLeft: "2rem" }}>
                        {textProperties.newUser}{" "}
                        <Link
                          to="/signup"
                          variant="body2"
                          className="link-text"
                          onClick={handleClose}
                          style={{ color: "rgb(234, 83, 85)" }}
                        >
                          {textProperties.signUp}
                        </Link>
                      </Grid>
                    </Grid>
                  </div>
                </Box>
                <Button
                  onClick={handleClose}
                  style={{ marginTop: "2rem", color: "rgb(234, 83, 85)" }}
                >
                  {textProperties.back}
                </Button>
              </Box>
            </Container>
          </ThemeProvider>
        </>
      </Modal>
      {/* {showToast ? (
        <Toast message="Successfully signed in!" show={showToast} />
      ) : null} */}
    </div>
  );
}

export default SignIn;
